export const LEFT_SIDE_MENU = "left_side_menu"; 
export const LEFT_SIDE_MENU_SUCCESSFULL = "left_side_menu_successfull";
export const VENDOR_LEFT_SIDE_MENU = "vendor_left_side_menu"; 
export const VENDOR_LEFT_SIDE_MENU_SUCCESSFULL = "vendor_left_side_menu_successfull";
